import { TanstackField } from 'src/utils/forms'

import RecordTypeStatusSelect from '../../Selects/RecordTypeStatusSelect'

type Props<TKey extends string> = {
  field: TanstackField<number | null | undefined, TKey>
  recordTypeId: number | null | undefined
  label?: string
  isRequired?: boolean
}
const RecordTypeStatusSelectField = <TKey extends string>({
  field,
  recordTypeId,
  label,
  isRequired,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  return (
    <RecordTypeStatusSelect
      recordTypeId={recordTypeId}
      value={field.state.value}
      onValueChange={field.setValue}
      label={label}
      isRequired={isRequired}
      onBlur={field.handleBlur}
      errorMessage={errorMessage}
    />
  )
}

export default RecordTypeStatusSelectField
